<template>
  <v-form ref="DataFieldForm" v-model="formValid" lazy-validation>
    <v-layout wrap>
      <v-flex xs12 md6 px-2>
        <v-text-field
          v-model="selectedDataField.field"
          label="Veldnaam uit IoT data"
          :rules="[formRules.field]"
          required
        ></v-text-field>
      </v-flex>	  
      <v-flex xs12 md6 px-2>
        <icon-picker v-model="selectedDataField.icon"></icon-picker>        
      </v-flex>
      <v-flex xs12 md6 px-2>
        <v-select
          :items="customFields"
		      item-value="id"
          item-text="name"          
          label="Type"
          v-model="selectedDataField.customFieldId"
          :rules="[formRules.customField]"
          required
        ></v-select>
      </v-flex>
      <v-flex x12 px-2>
        <v-switch label="Primaire dataveld" v-model="selectedDataField.isPrimary"></v-switch>
      </v-flex>	  	  
      <v-flex xs12 md6 px-2>
        <v-select
          :items="calculationUnits"
          item-text="label"
          item-value="key"
          label="Aanpassingtype op waarde dataveld"
          v-model="selectedDataField.modifier"
          required
        ></v-select>
      </v-flex>
      <v-flex xs12 md3 px-2>
        <v-text-field
		  mask="##########"
          v-model="selectedDataField.modifierValue"
          label="Aanpassingsfactor"
          :rules="[formRules.modifierValue]"
		  :disabled="!modifier"
          required
        ></v-text-field>        
      </v-flex>
      <v-flex xs12 md3 px-2>
        <v-text-field
		      mask="##########"
          v-model="selectedDataField.decimals"
          label="Aantal decimalen"
          :rules="[formRules.modifierValue]"
		      :disabled="!modifier"
          required
        ></v-text-field>
      </v-flex>
      <v-flex row xs12 wrap>
        <v-layout>
          <v-btn @click="cancel" color>Annuleren</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="save">Opslaan</v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-form>
</template>
<script>
import * as types from "../../store/types"
import { mapGetters } from "vuex"
import IconPicker from '../form/IconPicker'
export default {
  components:{
    IconPicker
  },
  data() {
    return {
      formValid: true,
      formRules: {
        name: value => {
          return value ? true : "Veld verplicht"
        },
        customField: value => {
          return value ? true : "Veld verplicht"
        },
        field: value => {
          return value ? true : "Veld verplicht"
        },
        modifierValue: value => {
          if(this.selectedDataField.modifier != ""){
            return value ? true : "Veld verplicht als er een aanpassingstype is gekozen"
          }       
		      return true;   
        }
      },
      selectedDataField: {
        id: "",
        name: "",
        icon:"",
        unitTypeId: this.unitTypeId,
        customFieldId:null,
        decimals: "",
        field: "",
        isPrimary: false,
        modifier: "",
        modifierValue: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      customFields: types.PROTECTED_CUSTOM_FIELDS,
      calculationUnits: types.HD_CALCULATION_UNITS
  	}),
    modifier(){
      return this.selectedDataField.modifier;
    }
  },
  props: {
    dataField: {
      type: Object
    },
    unitTypeId: {
      type: String,
      required: true
    }
  },
  methods: {
    save() {
      if (this.$refs.DataFieldForm.validate()) {
        let save = {}
			save.id				       = this.selectedDataField.id
      save.icon            = this.selectedDataField.icon
			save.field			     = this.selectedDataField.field
      save.customFieldId   = this.selectedDataField.customFieldId				
			save.isPrimary       = this.selectedDataField.isPrimary ? true : false		
			save.modifier		     = this.selectedDataField.modifier
      save.modifierValue	 = this.selectedDataField.modifierValue
      save.decimals	 = this.selectedDataField.decimals
			save.unitTypeId		   = this.selectedDataField.unitTypeId

        this.$store.dispatch(types.SAVE_DATA_FIELD, { data: save }).then(e => {
          this.selectedDataField.id = e.id
          this.$emit("saved", this.selectedDataField)
		});
      }
    },
    cancel() {
      this.$emit("cancelClicked")
	}
  },
  watch:{
	  modifier(){
		  this.$refs.DataFieldForm.validate()
		  if(!this.modifier){
			  this.selectedDataField.modifierValue=""
		  }
	  }
  },
  mounted() {
    if(this.customFields.length==0){
      this.$store.dispatch(types.PROTECTED_CUSTOM_FIELDS,{params:{per_page:200}})                              
    }	

    if (this.dataField) {      
      // use object assign to remove reference to prop
      this.selectedDataField.id                   = this.dataField.id
      this.selectedDataField.field                = this.dataField.field
      this.selectedDataField.icon                 = this.dataField.icon
      this.selectedDataField.modifier             = this.dataField.modifier
      this.selectedDataField.modifierValue        = this.dataField.modifierValue
      this.selectedDataField.decimals             = this.dataField.decimals
      this.selectedDataField.customFieldId        = this.dataField.customField.id
      this.selectedDataField.isPrimary            = this.dataField.isPrimary

    }
  }
}
</script>

<style scoped>
</style>